/**
 * Terminal workflow-run statuses — single source of truth (FR-012).
 *
 * Plain TypeScript with no Convex or React dependencies, importable by both
 * backend (`convex/workflowRuns.ts`) and frontend (`transforms/workflowRun.ts`).
 *
 * Terminal statuses per reconciled plan (specs/plan.md Section 1b):
 *   "cancelled", "completed", "completed_with_warnings", "completed_oscillating", "failed"
 */

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

/**
 * The exhaustive set of statuses that indicate a workflow run has reached a
 * terminal state. Adding a new terminal status here automatically propagates
 * to the backend idempotency check and the frontend `isTerminal` flag.
 */
export const TERMINAL_STATUSES = [
  "cancelled",
  "completed",
  "completed_with_warnings",
  "completed_oscillating",
  "failed",
] as const;

/** Union type of all terminal status strings. */
export type TerminalStatus = (typeof TERMINAL_STATUSES)[number];

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

/** Returns `true` when `s` is one of the known terminal statuses. */
export function isTerminalStatus(s: string): s is TerminalStatus {
  return (TERMINAL_STATUSES as readonly string[]).includes(s);
}
